import classes from "*.module.css";
import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core";
import React from "react";
import HistoryDetail from "../HistoryDetail";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    timeline: {
      // maxWidth: 1200,
      position: "relative",
      // margin: "0 auto",
      margin: 0,
      "&::after": {
        content: '" "',
        position: "absolute",
        width: 6,
        backgroundColor: "black",
        top: 0,
        bottom: 0,
        left: "50%",
        marginLeft: -3,
      },
    },
    timelineContainer: {
      padding: "10px 40px",
      position: "relative",
      backgroundColor: "inherit",
      width: "50%",
      "&::after": {
        content: '" "',
        position: "absolute",
        width: 25,
        height: 25,
        right: -12,
        backgroundColor: "white",
        border: "4px solid #bc243c",
        top: 15,
        borderRadius: "50%",
        zIndex: 1,
      },
    },
    timeLineLeft: {
      left: 0,
      "&::before": {
        content: '" "',
        height: 0,
        position: "absolute",
        top: 22,
        width: 0,
        zIndex: 1,
        right: 30,
        border: "medium solid white",
        borderWidth: "10px 0 10px 10px",
        borderColor: "transparent transparent transparent white",
      },
    },

    timeLineRight: {
      left: "50%",
      "&::before": {
        content: '" "',
        height: 0,
        position: "absolute",
        top: 22,
        width: 0,
        zIndex: 1,
        left: 30,
        border: "medium solid white",
        borderWidth: "10px 10px 10px 0",
        borderColor: "transparent white transparent transparent",
      },
      "&::after": {
        left: -12,
      },
    },
    timelineContent: {
      padding: "20px 30px",
      backgroundColor: "white",
      position: "relative",
      borderRadius: 6,
    },
  })
);

interface CustomTimeLineProps {
  historyArr: any;
}
function CustomTimeLine({ historyArr }: CustomTimeLineProps) {
  const classes = useStyles();

  return (
    <Grid component={"div"} className={classes.timeline} xs={12} item>
      {historyArr && historyArr.length > 0 ? (
        historyArr.map((element: any, index: any) => {
       
          if (index % 2 == 0) {
            return (
              <Grid
                component={"div"}
                className={`${classes.timelineContainer} ${classes.timeLineLeft}`}
                key={`history-${index}`}
              >
                <Grid
                  component={"div"}
                  className={classes.timelineContent}
                  style={{
                    background:
                      "linear-gradient( 307.97deg, #ffffff 16.02%, rgba(255,255,255,0) 59.08% ), #faf5ff",
                  }}
                >
                  <h2 style={{ fontWeight: 700 }}>{element.year}</h2>
                  <HistoryDetail detail={element.detail} />
                </Grid>
              </Grid>
            );
          } else {
            return (
              <Grid
                component={"div"}
                className={`${classes.timelineContainer} ${classes.timeLineRight}`}
                key={`history-${index}`}
              >
                <Grid
                  component={"div"}
                  className={classes.timelineContent}
                  style={{
                    background:
                      "linear-gradient( -307.97deg, #ffffff 16.02%, rgba(255,255,255,0) 59.08% ), #faf5ff",
                  }}
                >
                  <h2 style={{ fontWeight: 700 }}>{element.year}</h2>
                  <HistoryDetail detail={element.detail} />
                </Grid>
              </Grid>
            );
          }
        })
      ) : (
        <div></div>
      )}
      {/* <Grid
        component={"div"}
        className={`${classes.timelineContainer} ${classes.timeLineLeft}`}
      >
        <Grid component={"div"} className={classes.timelineContent}>
          <h2>2017</h2>
          <p>
            Lorem ipsum dolor sit amet, quo ei simul congue exerci, ad nec
            admodum perfecto mnesarchum, vim ea mazim fierent detracto. Ea quis
            iuvaret expetendis his, te elit voluptua dignissim per, habeo iusto
            primis ea eam.
          </p>
        </Grid>
      </Grid>
      <Grid
        component={"div"}
        className={`${classes.timelineContainer} ${classes.timeLineRight}`}
      >
        <Grid component={"div"} className={classes.timelineContent}>
          <h2>2017</h2>
          <p>
            Lorem ipsum dolor sit amet, quo ei simul congue exerci, ad nec
            admodum perfecto mnesarchum, vim ea mazim fierent detracto. Ea quis
            iuvaret expetendis his, te elit voluptua dignissim per, habeo iusto
            primis ea eam.
          </p>
        </Grid>
      </Grid> */}
    </Grid>
  );
}

export default CustomTimeLine;
